import { useTranslation } from 'react-i18next';

export default function ClashErrorState({ styles, error, onRetry, message }) {
  const { t } = useTranslation('zodiacClash');
  return (
    <div style={styles.errorContainer}>
      <div style={styles.errorIcon}>⚠️</div>
      <div style={styles.errorMessage}>{error || message || t('loadError')}</div>
      <button
        type="button"
        onClick={onRetry}
        style={styles.retryBtn}
        aria-label={t('retryLabel')}
      >
        {t('retry')}
      </button>
    </div>
  );
}
